import { createAction } from '@reduxjs/toolkit';
import { ToastMessage } from '../root-types';

export const addToastMessage = createAction<ToastMessage>('toast/ADD');
export const removeToastMessage = createAction<string>('toast/REMOVE');
